module.exports = __webpack_public_path__ + "static/OpenSans-Regular-79a2623395aedf27cb992e4a4af55e4e.woff";